import { getContractBasedDataSelector } from '@cp-shared-15/frontend-integration';
import { RootState } from '../../../store/rootReducer';

export const DealersDataSelector = getContractBasedDataSelector((state: RootState) => state.dealerDetails);
